import { BRANDS_DATA } from "../../services/BrandingService";

export default {
  translation: {
    "Welcome to React": "Bienvenue à React et react-i18next",
    Decoding: "Decodificación",
    "Phonological Awareness": "Conciencia fonológica",
    "High Frequency Words": "Palabras de alta frecuencia",
    "Background Knowledge": "Conocimientos previos",
    "Structure and Reasoning": "Estructuras y razonamiento",
    Vocabulary: "Vocabulario",
    "On Track": "Está al día",
    "Catch Up": "Necesita recuperar",
    Ahead: "Va por delante",
  },
  common: {
    grade_0: "kinder",
    grade_1: "primer grado",
    grade_2: "segundo grado",
    grade_3: "tercer grado",
    grade_4: "cuarto grado",
    grade_5: "quinto grado",
    grade_6: "sexto grado",
    English: "Inglés",
    Spanish: "Español",
    Confirm: "Confirmar",
    Cancel: "Cancelar",
    Proceed: "Proceder",
    Create: "Crear",
    Continue: "Continuar",
    Print: "Imprimir",
    Close: "Cerrar",
    sr_coming_soon:
      '{{brandedAppName}} todavía no calcula datos sobre "Estructuras y razonamiento". Esta opción estará disponible próximamente.',
    nth_pr: "{{percentile}} RP",
    PR: "PR",
    ahead: "Va por delante",
    catch_up: "Necesita recuperar",
    at_above: "Al nivel o por encima",
    on_track: "Por buen camino",
    developing: "En desarrollo",
    behind: "Por debajo",
    Fall: "Otono",
    Winter: "Invierno",
    Spring: "Primavera",
    Summer: "Verano",
    Practice: "Práctica",
    Assessment: "Evaluación",
    arm_score: "Puntuación ARM",
  },
  arm_floor: {
    arm_floor_tooltip_content:
      "Según las normas nacionales, la puntuación ARM de {{name}} indica que deben considerarse dos o más niveles de grado por detrás.",
  },
  teacher_parent_report: {
    "a 0 grade": "el kínder",
    "a 1 grade": "un primer grado",
    "a 2 grade": "un segundo grado",
    "a 3 grade": "un tercer grado",
    "a 4 grade": "un cuarto grado",
    "a 5 grade": "un quinto grado",
    "a 6 grade": "un sexto grado",
    "a 7 grade": "un grado séptimo",
    "a 8 grade": "un octavo grado",
    "0 month": "comienzo",
    "1 month": "primero mes",
    "2 month": "segundo mes",
    "3 month": "tercero mes",
    "4 month": "cuarto mes",
    "5 month": "quinto mes",
    "6 month": "sexto mes",
    "7 month": "séptimo mes",
    "8 month": "octavo mes",
    "9 month": "noveno mes",
    "10 month": "décimo mes",
    "the student_female": "la estudiante",
    "the student_male": "el estudiante",
    "the student_female_plural": "las estudiantes",
    "the student_male_plural": "los estudiantes",
    "Oral Reading Fluency Progress":
      "Progreso en la fluidez de la lectura oral",
    "Tips For Helping {{name}} Right Now":
      "Actividades para ayudar a {{name}} con la lectura de esta semana",
    "Understanding {{name}}'s Scores":
      "Interpretación de los resultados de {{name}}",
    parent_orf_score_tooltip:
      "Palabras correctas por minuto (PCPM) es la medida estándar de la fluidez en la lectura oral. El tamaño estimado del vocabulario es un buen indicador del nivel de comprensión y de conocimiento del mundo del estudiante. En ambos casos, cuanto mayor sea el número, mejor.",
    "Parent Report for {{name}}": "Informe para la familia de {{name}}",
    "Reading Progress": "Progreso de lectura",
    parent_arm_score_tooltip: `La puntuación ARM (dominio lector en Amira) de su hijo/a muestra su nivel de lectura según su edad. Mide la edad a la que su hijo lee de forma independiente. Una puntuación ARM de "5" indica una puntuación de lectura de un niño/a típico de 5 años (cual está dentro de la banda de lectura de jardín de infantes). El tamaño estimado del vocabulario es un buen indicador del nivel de comprensión y conocimiento de un estudiante. En ambos casos, un número mayor indica mayor crecimiento y dominio de la lectura.`,
    student_overall_arm_description:
      "El dominio lector global de {{name}} muestra la edad a la que lee de forma independiente. Una puntuación de {{score}} indica que está {{pacing}}.",
    student_overall_wcpm_description:
      "Palabras correctas por minuto (PCPM) es una medida de la fluidez en la lectura. Una PCPM de {{score}} indica que está {{pacing}}.",
    BELOW_GRADE_LEVEL: "Necesita recuperar",
    AT_GRADE_LEVEL: "Está al día",
    AHEAD_OF_GRADE_LEVEL: "Va por delante",
    Decoding: "Decodificación",
    "Phonological Awareness": "Conciencia fonológica",
    "Sight Recognition": "Palabras de alta frecuencia",
    "High Frequency Words": "Palabras de alta frecuencia",
    "Background Knowledge": "Conocimientos previos",
    "Structure & Reasoning": "Estructuras y razonamiento",
    Vocabulary: "Vocabulario",
    domain_descriptions: {
      Decoding:
        "La decodificación consiste en conocer la correspondencia entre letras y sonidos.",
      "Phonological Awareness":
        "La conciencia fonológica consiste en reconocer que las palabras están formadas por sonidos.",
      "Sight Recognition":
        "Las palabras de alta frecuencia son palabras de uso común. Los lectores aprenden a reconocerlas y leerlas sin identificar individualmente cada uno de sus sonidos.",
      "Background Knowledge":
        "Los conocimientos previos son la información general que se tiene acerca de un tema y que permite comprender una historia sobre ese tema.",
      "Structure & Reasoning":
        "El concepto de estructuras y razonamiento se refiere a la capacidad de análisis, evaluación y síntesis del texto.",
      Vocabulary:
        "El vocabulario es el conocimiento de las palabras y sus significados. Influye en la capacidad del estudiante de leer y comprender lo que lee.",
    },
    "{{name}}'s Overall Reading Mastery": "Dominio lector global de {{name}}",
    "Batch Print": "Impresión por lotes",
    "Scored better than {{percentage}}% of students":
      "Obtuvo mejor puntuación que el {{percentage}}% de los estudiantes.",
    "The {{leftScore}} to the left of the decimal indicates {{studentName}} is reading at {{currentGradeString}} level. The .{{rightScore}} to the right of the decimal indicates {{studentName}} is {{rightScore}}% of the way to {{nextGradeString}} reading level.":
      "El {{leftScore}} que está a la izquierda del punto decimal indica que  {{studentName}} lee a un nivel correspondiente a {{currentGradeString}}. El {{rightScore}} que está a la derecha del punto decimal indica que  {{studentName}} ha recorrido el  {{rightScore}}% del camino necesario para leer a un nivel correspondiente a {{nextGradeString}}.",
    "{{name}}'s Reading Subscores": "Supuntuaciones en lectura de {{name}}",
    parent_arm_score_info:
      "La puntuación ARM (dominio lector en Amira) de {{studentName}} muestra el nivel de grade en el que lee de forma independiente.",
    left_score_description:
      "El {{leftScore}} a la izquierda del decimal representa un nivel de lectura de {{currentGradeString}}.",
    right_score_description:
      "El .{{rightScore}} a la derecha del decimal indica el {{rightScoreDescription}} del año escolar.",
    print_language_label: "Idioma de impresión",
  },
  teacher_report_chart_progress: {
    WCPM: "PCPM",
    "Student’s ability to read aloud with natural ease":
      "Palabras correctas por minuto",
    Lexile: "Lexile",
    AREA: "AREA",
    "Amira Reading Estimated Age": "Edad lectora estimada por Amira",
    EHFWI: "IEPAF",
    "Expected High Frequency Words Inventory":
      "Inventario estimado de palabras de alta frecuencia",
    PSF: "FSF",
    "Phoneme Segmentation Fluency": "Fluidez en la segmentación de fonemas",
    EVS: "TEV",
    "Estimated words in vocabulary": "Tamaño estimado del vocabulario",
    ARM: "ARM",
    "Amira reading mastery": "Dominio de la lectura según Amira",
    "Latest Score": "Último resultado",
    "Predicted Ability": "Habilidad prevista",
    "Estimated Mastery": "Dominio estimado",
    Excellent: "Excelente",
    Average: "Promedio",
    "Below Expectations": "Necesita practicar más",
    Jan: "enero",
    Feb: "feb.",
    Mar: "marzo",
    Apr: "abr",
    May: "mayo",
    Jun: "jun.",
    Jul: "jul",
    Aug: "agosto",
    Sep: "set.",
    Oct: "oct.",
    Nov: "nov.",
    Dec: "dic.",
  },
  teacher_dyslexia_letter: {
    Dear: "Estimado",
    Sincerely: "Atentamente",
    parent_letter_p1:
      "Le agradecemos su inestimable colaboración durante el proceso educativo de {{name}}. Cada año todos los estudiantes de nuestra comunidad participan en una prueba de evaluación para la dislexia ofrecido por Amira. Esta prueba se asemeja a una evaluación de lectura en la que los alumnos tienen que completar diversas tareas lingüísticas con el objetivo de identificar posibles riesgos de padecer dislexia. Sin embargo, hay que aclarar que esta prueba no ofrece un diagnóstico definitivo. Aproximadamente, una de cada cinco personas son diagnosticadas con dislexia y una detección temprana a través de este tipo de pruebas es necesaria para ayudar a los estudiantes a alcanzar su potencial académico. Para una información detallada sobre la dislexia puede visitar",
    parent_letter_p2:
      "Su hijo/a terminó la evaluación para la dislexia de Amira el {{date}} y puede comprobar sus resultados más abajo. Le recomendamos leer estos resultados de la misma forma en la que se lee el tablero de instrumentos de un vehículo. El tablero ofrece señales luminosas que informan del estado de los componentes de su vehículo y, de la misma forma, esta prueba de evaluación muestra cuáles son las fortalezas y las áreas de mejora de su hijo/a. Esta información resulta muy valiosa para que usted, su hijo/a y la escuela puedan trabajar juntos con el fin de alcanzar los objetivos académicos. La prueba de evaluación nos ofrece información sobre las habilidades en áreas como la identificación de letras, la segmentación de los sonidos de palabras y la decodificación por medio del emparejamiento de letras y sonidos. Todos los niños y niñas tienen fortalezas y áreas de mejora.",
    parent_letter_p3:
      "Los resultados de la prueba de evaluación para la dislexia indican que {{name}} tiene dificultades lectoras o áreas de mejora que suelen estar asociadas con la dislexia. De nuevo, es importante señalar que esta prueba muestra indicios relativos a la dislexia, pero no es una prueba diagnóstica formal. Con base en estos resultados, {{name}} podría tener acceso a una evaluación adicional o a apoyo académico. Es importante que usted lea los resultados detenidamente y considere la lectura como una prioridad para su hijo/a.",
    parent_letter_p4:
      "Alrededor de uno de cada cinco estudiantes muestra señales de riesgo relacionadas con la dislexia y, por tanto, es necesario estar informado y tener una actitud proactiva frente a ello. Si usted necesita ayuda para entender los resultados de su hijo/a o cómo ofrecerle ayuda, por favor no dude en contactarme para que podamos reunirnos. Como docente, seguiré monitoreando el rendimiento de su hijo/a, le mantendré al día del progreso de sus habilidades y compartiré con usted herramientas que ayuden a mejorar la lectura.",
    parent_letter_p5:
      "No dude en contactarme si tiene preguntas, aquí estoy para acompañarlos en este proceso.",
    activity_log:
      "Usted puede apoyar a su hijo/a con su desarrollo en las las habilidades mencionadas anteriormente. También puede estar atento a las comunicaciones adicionales que proporcionará la escuela. Por último, he incluido un registro de actividades a continuación, que puede usar para realizar un seguimiento de la práctica de habilidades en casa.",
    Domain: "Dominio",
    PR: "Rango de percentiles",
    Status: "Estado actual",
    Description: "Descripción",
    "Home Activity Log": "Registro de actividades en el hogar",
    Goal: "Meta",
    "Activity we tried": "Actividades que hemos probado",
    how_it_went:
      "Califique esta actividad (Circule la cara que mejor representa su opinión)",
    example_goal: "Ejemplo de una meta: aprender sonidos de letras",
    example_activity:
      "Seleccione una página de un libro con el que su hijo esté familiarizado. Pregúnteles qué letras reconocen y los sonidos asociados con esas letras.",
  },
  badge_certificate: {
    your_award: "TU PREMIO DE {{brandedAppName}}",
    honors_you_for: "{{brandedAppName}} te otorga este reconocimiento por",
    achieved: "Logro",
  },
  reports: {
    title: "Seleccionar un informe",
    review_activity: "Revisar actividad",
    reports: "Informes",
    log_out: "Cerrar sesión",
    help: "Ayuda",
    bilingual: "Bilingüe",
    english: "Inglés",
    "Batch Print": "Impresión por lotes",
    generating_batch_report: "Generando informe de impresión por lotes",
    seconds_left: "Faltan aproximadamente {{seconds}} segundos",
    minutes_left: "Faltan aproximadamente {{minutes}} minutos",
    "Exit Batch Print": "Salir de la impresión por lotes",
    no_scores_available: "Aún no hay puntuaciones disponibles",
    work_with_amira: "trabaje con {{brandedAppName}}",
    works_with_amira: "trabajen con {{brandedAppName}}",
    once_your_student: "Cuando su estudiante",
    once_your_students: "Cuando sus estudiantes",
    you_can_view_their: "usted podrá ver su",
    here: "aquí",
    assessments_must_clear:
      "La puntuación de las evaluaciones puede demorar hasta 72 horas debido al proceso de revisión de calidad de {{brandedAppName}}.",
    no_adjusted_scores: "Aún no hay puntuaciones con ajuste disponibles",
    completes_equated_activity:
      "complete una actividad que prevé la puntuación con ajuste en {{brandedAppName}}",
    complete_equated_activity:
      "completen una actividad que prevé la puntuación con ajuste en {{brandedAppName}}",
    switch_to_unadjusted:
      'Para ver informes de toda la actividad, cambie el tipo de puntuación a "Sin ajuste (puntuación bruta)".',
    // reports homepage
    tracking_label: "INFORME DE SEGUIMIENTO",
    tracking_description: "Ver estado y asignar evaluaciones",
    tracking_tagline: "estado de las evaluaciones; gestión de tareas",
    benchmark_label: "INFORME DE REFERENCIA",
    benchmark_description: "Resumen del desempeño de la clase",
    benchmark_tagline:
      "comparado con expectativas, intervenciones, límites de puntuación, clasificación estudiantil",
    progress_label: "INFORME DE PROGRESO",
    progress_description: "Ver desempeño a lo largo del tiempo",
    progress_tagline:
      "grabaciones de estudiantes, monitoreo del progreso, línea de tendencia, desarrollo estudiantil",
    readingrope_label: "RECOMENDACIONES PEDAGÓGICAS",
    readingrope_description:
      "Visualización del dominio según el modelo de la cuerda lectora",
    readingrope_tagline:
      "Otorga puntuaciones a cada estudiante para generar una puntuación de dominio global con recomendaciones pedagógicas",
    skillsstatus_label: "ESTADO ACTUAL DE LAS HABILIDADES",
    skillsstatus_description: "Nivel de dominio de habilidades de la clase",
    skillsstatus_tagline:
      "Ver y agrupar el dominio de cada habilidad de todos los estudiantes de su clase",
    skillsdiagnostic_label: "DIAGNÓSTICO DE LAS HABILIDADES",
    skillsdiagnostic_description: "Visión global de cada estudiante",
    skillsdiagnostic_tagline:
      "Revisar el nivel de dominio de cada habilidad en cada componente de la cuerda lectora para estudiantes individuales",
    classprogress_label: "INFORME DE PROGRESO DE LA CLASE",
    classprogress_description:
      "Comparar las puntuaciones de las evaluaciones a lo largo del tiempo",
    classprogress_tagline:
      "Ver el progreso de todos los estudiantes de su clase en diversos indicadores",
    dyslexiarisk_label: "INFORME SOBRE EL RIESGO DE DISLEXIA",
    dyslexiarisk_description: "Identificar estudiantes bajo riesgo",
    dyslexiarisk_tagline:
      "límites de puntuación, probabilidad de padecer dislexia",
    badging_label: "INFORME DE INSIGNIAS",
    badging_description: "Ver y otorgar insignias",
    badging_tagline:
      "Celebrar el uso y los logros de los estudiantes de su clase",
    parent_label: "INFORME PARA LA FAMILIA",
    parent_description:
      "Compartir información actualizada y accesible con las familias",
    parent_tagline:
      "Resumen del progreso, oportunidades para apoyar el desarrollo",
    // tooltips
    tooltip_scoreType:
      "Las puntuaciones ajustadas toman en cuenta los diferentes niveles de dificultad de los textos leídos.",
    tooltip_scale: "Cambie la escala a Lexile, EDL o PCPM.",
    tooltip_benchmarks:
      "Los puntos de referencia nacionales se basan en los resultados de estudiantes de todo el país. De existir, su distrito proporcionará sus propios puntos de referencia a {{brandedAppName}}.",
    tooltip_metric:
      "Cambie la escala a Fluidez en la lectura oral, Dominio lector en Amira, Dominio lector, Palabras de alta frecuencia, Conciencia fonológica o Tamaño del vocabulario.",
    tooltip_curriculum:
      "Elija un currículo y vea su alcance y secuencia en este informe. Para ver el progreso de sus estudiantes en el andamiaje para lectores principiantes, elija {{curriculumName}}.",
    tooltip_pr:
      "El RP es el rango percentil del estudiante, basado en su desempeño en comparación con otros estudiantes para el punto de referencia",
    tooltip_readingLevel:
      "En la ciencia de la lectura, no se nivela a los estudiantes. Estos datos son tan solo una indicación de la complejidad del texto que el estudiante puede leer sin experimentar frustración.",
    tooltip_riskLevel:
      "La presencia de riesgo no equivale a un diagnóstico. {{brandedAppName}} genera una alerta temprana si un estudiante parece presentar patrones de lectura asociados a la dislexia.",
    tooltip_atRisk:
      'Cualquier estudiante con una puntuación superior a 30 está "en situación de riesgo". Los signos graves varían en función del grado, pero suelen estar asociados a puntuaciones de treinta y cinco o más.',
    // legend
    "English Reading Risk": "Riesgo lector en inglés",
    "Spanish Reading Risk": "Riesgo lector en español",
    "At Risk, Stronger Signals": "En situación de riesgo, signos graves",
    "At Risk, Weaker Signals": "En situación de riesgo, signos leves",
    "Low Risk": "Riesgo bajo",
    "Risk Cutline": "Límite de riesgo",
  },
  reports_sidebar: {
    // translations for report sidebar
    back_to_reports: "VOLVER A TODOS LOS INFORMES",
    "Tracking Report": "Informe de seguimiento",
    "Benchmark Report": "Informe de referencia",
    "Progress Report": "Informe de progreso",
    "Reading Rope": "Cuerda de lectura",
    "Skills Status": "Estado de habilidades",
    "Skills Diagnostic": "Diagnóstico de habilidades",
    "Class Progress Report": "Informe de progreso de clase",
    "Dyslexia Risk": "Riesgo de dislexia",
    "Badging Report": "Informe de insignias",
    "Parent Report": "Informe para padres",
    score_configuration: "CONFIGURACIÓN DE LA PUNTUACIÓN",
    metric: "INDICADOR",
    ARM: "Dominio lector en Amira (ARM)",
    ORF: "Fluidez en la lectura oral (FLO)",
    SightRecognition: "Palabras de alta frecuencia",
    PhonologicalAwareness: "Conciencia fonológica",
    VocabSize: "Tamaño del vocabulario",
    score_type: "TIPO DE PUNTUACIÓN",
    equated: "Con ajuste (para comparación)",
    unequated: "Sin ajuste (puntuación bruta)",
    scale: "ESCALA",
    WCPM: "Palabras correctas por minuto (PCPM)",
    Lexile: "Lexile",
    DRA: "Evaluación del desarrollo de la lectura",
    benchmarks: "PUNTOS DE REFERENCIA",
    "National Norms": "Normas nacionales",
    "Spanish Norms": "Normas en español",
    District: "Distrito",
    Kindergarten: "Kindergarten",
    "Grade 1": "Primer grado",
    "Grade 2": "Segundo grado",
    "Grade 3": "Tercer grado",
    "Grade 4": "Cuarto grado",
    "Grade 5": "Quinto grado",
    "Grade 6": "Sexto grado",
    language: "IDIOMA",
    english: "Inglés",
    spanish: "Español",
    reading_risk_type: "TIPO DE RIESGO LECTOR",
    english_reading_risk: "Riesgo lector en inglés",
    spanish_reading_risk: "Riesgo lector en español",
    testing_window: "VENTANA DE EVALUACIÓN",
    Fall: "Otoño",
    Winter: "Invierno",
    Spring: "Primavera",
    current: "actual",
    assessment_type: "TIPO DE EVALUACIÓN",
    benchmark_only: "Solo evaluación de referencia",
    latest_assessment: "Última evaluación (incluido el monitoreo del progreso)",
    configuration: "CONFIGURACIÓN",
    show_subscores: "Mostrar subpuntuaciones",
    show_tips: "Mostrar consejos para las familias",
    Decoding: "Decodificación",
    "Phonological Awareness": "Conciencia fonológica",
    "High Frequency Words": "Palabras de alta frecuencia",
    "Background Knowledge": "Conocimientos previos",
    Vocabulary: "Vocabulario",
    "Structures & Reasoning": "Estructuras y razonamiento",
    badges_earned_in: "Mostrar las insignias ganadas en:",
    usage_window: "VENTANA DE USO",
    school_year: "Año escolar",
    this_week: "Semana actual ({{labelStart}} al {{labelEnd}})",
    last_week: "Semana anterior ({{labelStart}} al {{labelEnd}})",
    usage_week: "{{labelStart}} al {{labelEnd}}",
    curriculum: "CURRÍCULO",
    "Amira Default": "Predeterminado de Amira",
    "EPS Spire": "Spire de EPS",
    "Type or select a student": "Elija el nombre del estudiante",
    "Loading student data": "Cargando datos",
    "Select...": "Seleccionar...",
    "report_type": "TIPO DE INFORME",
    "class_progress": "Progreso de la clase",
    "thread_overview": "Componentes de la cuerda",
  },
  tracking_report: {
    "First Name": "Nombre",
    "Last Name": "Apellido",
    "Tutoring Time": "Tiempo de tutoría",
    "Stories Read": "Historias leídas",
    "This Week": "Esta semana",
    "Review Skills": "Revisar habilidades",
    "Assessment Status": "Estado de la evaluación",
    Language: "Idioma",
    // assessment statuses
    unassessed: "Sin evaluar",
    assigned: "Programada",
    in_progress: "En curso",
    error: "Reevaluar",
    scoring: "Puntuación",
    complete: "Completada",
    under_review: "Bajo revisión",
    "pre-reader": "Lector principiante",
    incomplete: "Incompleta",
    district_assigned: "Distrito asignado",
    // assessment status labels
    unassessed_label: "Sin evaluar",
    assigned_label: "Programada el {{month}}/{{day}}",
    in_progress_label: "En curso",
    error_label: "Reevaluar {{month}}/{{day}}",
    scoring_label: "Puntuación {{month}}/{{day}}",
    complete_label: "Completada {{month}}/{{day}}",
    under_review_label: "Bajo revisión {{month}}/{{day}}",
    "pre-reader_label": "Lector principiante {{month}}/{{day}}",
    incomplete_label: "Incompleta {{month}}/{{day}}",
    district_assigned_label: "Distrito asignado",
    // assessment status tooltips
    means: "significa que",
    unassessed_description:
      "al estudiante no se le ha asignado una evaluación en la <b>ventana</b> actual de evaluación. Si su escuela está usando {{brandedAppName}} en modo de práctica, el estudiante recibirá historias de práctica hasta que se le asigne una evaluación.",
    [`unassessed_description_nwea-map-tutor_override`]:
      "the student has not been assigned an assessment in the <b>current</b> testing window. If your school is using MAP Reading Fluency assessments, the student will get practice stories until assigned.", // TRANSLATE
    unassessed_cta:
      "Para evaluar al estudiante, asigne una evaluación y pídale al estudiante que inicie sesión en {{brandedAppName}} como de costumbre.",
    [`unassessed_cta_nwea-map-tutor_override`]:
      "To assess the student, utilize MAP Reading Fluency to assign a benchmark test and execute student testing there.", // TRANSLATE
    assigned_description:
      "al estudiante se le ha asignado una evaluación que se realizará durante su próximo inicio de sesión.",
    assigned_cta:
      "Pídale al estudiante que inicie sesión y complete la evaluación.",
    in_progress_description:
      "el estudiante está completando una evaluación en este momento. La evaluación se puntuará una vez se haya completado.",
    in_progress_cta:
      "Cuando el estudiante haya completado la evaluación, compruebe la puntuación en el Informe de referencia. Si el estudiante cerró la sesión durante la evaluación, podrá completarla la próxima vez que inicie sesión.",
    error_description:
      "el estudiante completó la evaluación, pero hubo un problema que invalidó la puntuación. Se consideran, entre otros factores, los ruidos de fondo elevados, las calidades de sonido bajas que impiden obtener una puntuación precisa y los intentos de lectura demasiado breves como para estimar correctamente la capacidad del estudiante. Estas señales indican que reevaluar al estudiante podría generar resultados significativamente distintos.",
    error_cta:
      "Haga clic en el nombre del estudiante, vuelva a asignar la evaluación y pídale al estudiante que inicie sesión para realizarla. (Antes de volver a evaluar al estudiante, compruebe sus auriculares o cualquier pestaña abierta que pueda interferir con el archivo de audio).",
    scoring_description:
      "la evaluación se guardó y está siendo puntuada. El proceso de puntuación puede tardar desde unos minutos hasta varias horas.",
    scoring_cta:
      "Espere a que finalice el proceso de puntuación y compruebe la puntuación en el Informe de referencia. Si visualiza el estado de PUNTUACIÓN por más de 24 horas, escríbanos por chat o póngase en contacto con soporte.",
    complete_description:
      "el estudiante completó la evaluación. La puntuación del estudiante está disponible en el Informe de referencia.",
    complete_cta:
      "Si su escuela está usando {{brandedAppName}} en modo de práctica, pídale al estudiante que inicie sesión y trabaje con {{brandedAppName}} varias veces por semana.",
    under_review_description:
      "la sesión de evaluación ha sido marcada para una revisión de calidad detallada. El proceso de revisión puede tardar 3 días laborables, sin incluir el día en que se realizó la evaluación. Por ejemplo, una evaluación completada el lunes se revisará para el viernes por la mañana.",
    under_review_cta:
      'Vuelva a comprobar en unos días. El estado cambiará a "Completada" o "Reevaluar" una vez se haga la revisión. Si esto toma más de 5 días laborables, escríbanos por chat o póngase en contacto con soporte.',
    "pre-reader_description":
      "el estudiante no pudo leer el texto de kínder o no leyó correctamente suficientes palabras para otorgarle una puntuación.",
    "pre-reader_cta":
      "Si está de acuerdo en que el estudiante es un lector principiante, pídale que inicie sesión y trabaje con {{brandedAppName}} usando el andamiaje para lectores principiantes. Si no está de acuerdo, revise el audio del estudiante y, si considera que lee bien, retírelo del andamiaje para lectores principiantes o asígnele una nueva evaluación.",
    not_completed_description:
      "la sesión del estudiante terminó antes de completar la evaluación. Esto puede ocurrir si el estudiante cierra o abandona el navegador.",
    not_completed_cta:
      "Pídale al estudiante que inicie sesión y reanude la evaluación.",
    district_assigned_description:
      "su distrito ha creado una ventana de evaluación. Se evaluará a este estudiante en cuanto inicie sesión en {{brandedAppName}}.",
    district_assigned_cta:
      "Pídale al estudiante que inicie sesión y complete la evaluación.",
    // controls
    "Assign Benchmark Assessment": "Asignar evaluación de referencia",
    "Assign Progress Monitor": "Asignar monitoreo del progreso",
    "Assign Calibration": "Asignar calibración",
    "Configure Practice": "Configurar práctica",
    "Configure District Assessment": "Configurar evaluación de distrito",
    "Unassign Assessment": "Anular asignación de evaluación",
    // assignment
    benchmark_label: "Evaluación de referencia",
    benchmark_description:
      "Estos estudiantes recibirán la evaluación de referencia a continuación",
    progress_monitoring_label: "Monitoreo del progreso",
    progress_monitoring_description:
      "Estos estudiantes recibirán el monitoreo del progreso a continuación",
    calibration_label: "CALIBRACIÓN",
    calibration_description:
      "Estos estudiantes recibirán el formulario de calibración a continuación",
    "STUDENT ASSESSMENT CONFIGURATION":
      "CONFIGURACIÓN DE LAS EVALUACIONES DE LOS ESTUDIANTES",
    sessions: "{{count}} sesión",
    sessions_plural: "{{count}} sesiones",
    "English Only": "Solo inglés",
    "Spanish Only": "Solo español",
    "English & Spanish": "Inglés y español",
    "Manage Language": "Gestionar idioma",
    assessment_configuration:
      "Configuración de las evaluaciones de {{studentName}}",
    "SELECT LANGUAGES": "SELECCIONAR IDIOMAS",
    English: "Inglés",
    Spanish: "Español",
    TASKS: "TAREAS",
    tasks_description:
      "Las siguientes tareas aparecerán en la próxima evaluación. Estas tareas han sido configuradas por su distrito. Las insignias establecidas como objetivo indican su correspondencia con el informe del modelo de la cuerda lectora.",
    Task: "Tarea",
    Description: "Descripción",
    "Reading Rope Domains": "Componentes de la cuerda lectora",
    // tasks
    assessment_name: "Fluidez en la lectura oral",
    assessment_info:
      "Esta tarea consiste en leer un texto para determinar la fluidez global y el dominio de otros elementos. El texto se adaptará de forma dinámica para medir mejor la destreza de cada estudiante.",
    nwf_name: "Fluidez en palabras sin sentido",
    nwf_info:
      "Esta tarea requiere que el estudiante lea pseudopalabras para evaluar sus habilidades de decodificación.",
    spelling_name: "Ortografía",
    spelling_info:
      "Esta tarea evaluará la capacidad ortográfica y de codificación del estudiante.",
    listeningComprehension_name: "Comprensión auditiva",
    listeningComprehension_info:
      "Los estudiantes contestarán preguntas sobre una historia que han escuchado para evaluar sus habilidades de comprensión auditiva.",
    vocabularyScreener_name: "Vocabulario",
    vocabularyScreener_info:
      "Esta tarea consiste en elegir la descripción o la imagen que mejor se ajusta a la definición de una palabra.",
    readingComprehension_name: "Comprensión lectora",
    readingComprehension_info:
      "Los estudiantes contestarán preguntas sobre el texto que han leído para evaluar sus habilidades de comprensión.",
    ran_name: "RAN",
    ran_info:
      "La prueba de nombramiento rápido automatizado (RAN) requiere que el estudiante identifique y articule los elementos de una lista larga. Se miden la velocidad de procesamiento y la precisión.",
    letterSounds_name: "Sonidos de letras",
    letterSounds_info:
      "Se le muestra al estudiante una letra y se le pide que pronuncie su sonido. Si la prueba es en inglés, se aceptan varias respuestas para cada vocal.",
    wordReading_name: "Lectura de palabras",
    wordReading_info:
      "Se le muestran al estudiante, de una en una, las palabras de un texto. El estudiante debe leer cada palabra.",
    blending_name: "Combinación",
    blending_info:
      "Se muestra un video de una persona que articula lentamente cada uno de los fonemas de una palabra. Los estudiantes deben combinar los sonidos para formar la palabra completa con precisión.",
    calibration_name: "Calibración",
    calibration_info:
      "Esta tarea consiste en leer un texto para determinar la fluidez global y el dominio de otros elementos. El texto se adaptará de forma dinámica para medir mejor la destreza de cada estudiante.",
    wordManipulation_name: "Manipulación de palabras",
    wordManipulation_info:
      "Los estudiantes escuchan una palabra de dos sílabas (por ejemplo, “béisbol”) y se les pide que contesten eliminando una de las sílabas. Toda la actividad se realiza oralmente, sin palabras ni imágenes escritas.",
    nonsenseWordReplication_name: "Repetición de palabras sin sentido",
    nonsenseWordReplication_info:
      "Se le muestran al estudiante una serie de ítems que se utilizarán en la próxima evaluación de la dislexia de Amira.",
    letterNamingAndSounds_name: "Letter Naming and Sounds", // TRANSLATE
    letterNamingAndSounds_info: "The student is shown a letter and asked to name the letter and make the associated sound.",
    // practice modal
    practiceModalSubject: "{{studentName}} y otro estudiante",
    practiceModalSubject_plural:
      "{{studentName}} y {{count}} otros estudiantes",
    configure_practice: "Configurar práctica para {{subject}}",
    practice_reading: "{{subject}} practicará la lectura en",
    "English and Spanish": "Inglés y Español",
    "District Default": "Configuración predeterminada del distrito",
    Next: "Siguiente",
    Update: "Actualizar",
    Configure: "Configurar práctica en",
    practice_for: "para {{subject}}",
    amira_label: "Práctica estándar de {{brandedAppName}}",
    amira_description:
      "Los estudiantes leen textos en voz alta con microintervenciones por parte de {{brandedAppName}}.",
    erss_label: "Andamiaje para lectores principiantes",
    erss_description:
      "Una secuencia de actividades de práctica con múltiples apoyos",
    tutor_language_config:
      "{{brandedAppName}} asistirá a {{subject}} en el siguiente idioma",
    configure_bilingual_assessment:
      "Configurar evaluaciones bilingües para {{subject}}",
    only_bilingual_updated:
      "Nota: Solo se actualizarán los estudiantes bilingües",
    district_assignments_taken_in:
      "Las evaluaciones asignadas a {{subject}} por el distrito se realizarán en:",
    // activity modal
    "Activity This Week": "Actividad de esta semana",
    "Less than 1 minute": "Menos de 1 minuto",
    minute: "minuto",
    minute_plural: "minutos",
    "Minutes Reading": "Minutos leídos",
    "Tutoring Time": "Tiempo de tutoría",
    "Complete Stories": "Historias Completadas",
    "Incomplete Stories": "Historias Incompletas",
    // warnings
    replace_district_assessment:
      "Al asignar esta tarea, se sustituirá la evaluación de distrito programada. Asegúrese de que eso es lo que desea hacer.",
    proceed_with_assignment: "Proceder con la asignación de la tarea",
    cancel_and_use_district_assignment:
      "Cancelar y usar la tarea asignada por el distrito",
    no_assignable_students:
      "No queda ningún estudiante elegible para asignar esta tarea de calibración.",
    // screening window
    active_screening_window: "Hay una ventana de evaluación activa en su distrito. Los estudiantes que inicien sesión tendrán que realizar una evaluación. No se requiere ninguna acción de su parte.",
    screening_window_set: "Ventana de evaluación configurada - {{window}} Evaluación",
    active_ends_on: "Activa hasta el {{month}}/{{day}}",
    benchmark_screener: "Evaluación de referencia",
  },
  benchmark_report: {
    Student: "Estudiante",
    "25th PR": "RP 25",
    "50th PR": "RP 50",
    "75th PR": "RP 75",
    "No Arm Score": "Sin puntuación ARM",
    Unassessed: "Sin evaluar",
    "Instructional Text Complexity": "Complejidad del texto instrucción",
    "Level A": "Nivel A",
    "Level B": "Nivel B",
    "Level C": "Nivel C",
    "Level D": "Nivel D",
    "Level E": "Nivel E",
    "Level F": "Nivel F",
    "Level G": "Nivel G",
    "Level H": "Nivel H",
    "Level I": "Nivel I",
    "Level J": "Nivel J",
    "Level K": "Nivel K",
    "Level L": "Nivel L",
    "Level M": "Nivel M",
    "Level N": "Nivel N",
    "Level O": "Nivel O",
    "Level P": "Nivel P",
    "Level Q": "Nivel Q",
    "Level R": "Nivel R",
    "Level S": "Nivel S",
    "Level T": "Nivel T",
    "Level U": "Nivel U",
    "Level V": "Nivel V",
    "Level W": "Nivel W",
    "Level X": "Nivel X",
    "Level Y": "Nivel Y",
    "Level Z": "Nivel Z",
  },
  badging_report: {
    "BACK TO BADGING REPORT": "VOLVER AL INFORME DE INSIGNIAS",
    newBadgeNotification: "¡Usted tiene {{count}} nueva insignia para otorgar!",
    newBadgeNotification_plural:
      "¡Usted tiene {{count}} nuevas insignias para otorgar!",
    "Award All": "Otorgar Todo",
    "My class usage": "Uso de mi clase",
    "Our Students": "Nuestros estudiantes",
    "Showing usage data": "Se muestran los datos de uso",
    "and badges earned": "y las insignias ganadas",
    "for the entire school year": "durante todo el año escolar",
    for_usage_week: "del {{labelStart}} al {{labelEnd}}",
    badges: "insignias",
    stories: "historias",
    minutes: "minutos",
    "Last Name": "Apellido",
    "First Name": "Nombre",
    "Tutoring Time": "Tiempo de tutoría",
    "Stories Read": "Historias leídas",
    "Badges Earned": "Insignias ganadas",
    "New Awards": "Premios nuevos",
    "Total Sessions": "Total de sesiones",
    "Minutes This Week": "Minutos de esta semana",
    WCPM: "PCPM",
    "Skills Scaffold Graduation":
      "Graduación del andamiaje para lectores principiantes",
    "New High": "Nuevo récord de puntuación",
    "Built By You": "Generado por usted",
    awardButton: "Otorgar {{count}} Insignia",
    awardButton_plural: "Otorgar {{count}} Insignias",
    printButton: "Imprimir {{count}} Insignia",
    printButton_plural: "Imprimir {{count}} Insignias",
    "Build Certificates": "Generar Certificados",
    "Export to CSV": "Exportar a CSV",
    "Usage Data": "Datos de uso",
    "Certificate Builder": "Generador de certificados",
    "Reward Level": "Nivel del premio",
    Language: "Idioma",
    "Class Name": "Nombre de la clase",
    English: "Inglés",
    Spanish: "Español",
    Description: "Descripción",
    "Create Badges": "Crear insignias e imprimir certificados",
    Cancel: "Cancelar",
    Preview: "VISTA PREVIA",
    "Coming Soon!": "¡Próximamente!",
    // print certificates modal
    "Print Certificates": "Imprimir certificados",
    award_eligible_badges:
      "Algunas de las insignias seleccionadas no se han otorgado todavía. Haga clic en “Proceder” para otorgar las insignias elegibles antes de imprimir los certificados.",
    "Certificate Color": "Color del certificado",
    select_certificate_color:
      "Seleccione si quiere imprimir los certificados a color o en blanco y negro.",
    Color: "Color",
    "Black/White": "Blanco y negro",
  },
  progress_report: {
    Fall: "Otoño",
    Winter: "Invierno",
    Spring: "Primavera",
    "Predicted Ability": "Habilidad prevista",
    "Estimated Mastery Today": "Dominio estimado hoy",
    "by end of school year": "al final del año escolar",
    "Percentile Rank": "Rango percentil",
    "based on National Norms": "según las normas nacionales",
    "Activity Type": "Tipo de actividad",
    ARM: "ARM",
    "Story Name": "Nombre de la historia",
    "Story Grade": "Grado de la historia",
    "Session Time": "Tiempo de sesión",
    Date: "Fecha",
    Above: "Por encima del",
    Below: "Por debajo del",
  },
  reading_rope_report: {
    Vocabulary: "Vocabulario",
    "Background Knowledge": "Conocimientos previos",
    "Structures & Reasoning": "Estructuras\u00A0y razonamiento",
    "Structure & Reasoning": "Estructura y razonamiento",
    "Phonological Awareness": "Conciencia fonológica",
    Decoding: "Decodificación",
    "High Frequency Words": "Palabras\u00A0de alta\u00A0frecuencia",
    Comprehension: "Comprensión",
    "Overall Mastery": "Dominio global",
    Percentile: "Percentil",
    "ARM Score": "Puntuación ARM",
    "Word Recognition": "Reconocimiento de\u00A0palabras",
    "Current Mastery": "Dominio actual",
    "current_mastery_with_name": "Dominio actual de {{studentName}}",
    "What's Next": "Qué es lo próximo",
    "To Improve...": "Por Mejorar...",
    "Skills Coming Soon...": "Siguientes habilidades...",
    "View Details": "Ver detalles",
  },
  skills_status_report: {
    "Student Name": "Nombre del estudiante",
    Fall: "Otoño",
    Winter: "Invierno",
    Spring: "Primavera",
    "Pre-K": "Prekínder",
    Kindergarten: "Kínder",
    "First Grade": "Primer grado",
    "Second Grade": "Segundo grado",
    "Third Grade": "Tercer grado",
    "Fourth Grade": "Cuarto grado",
    "Fifth Grade": "Quinto grado",
    "Sixth Grade": "Sexto grado",
    "Not Developed": "Por desarrollar",
    Developing: "En desarrollo",
    Mastered: "Dominado",
    observation: "observacion",
    observation_plural: "observaciones",
    error: "error",
    error_plural: "errores",
    "Skill Level": "Nivel de habilidades",
    "Pre-K": "Prekínder",
    Resources: "Recursos",
    no_resources: "No hay ningún recurso para mostrar.",
    fetch_error: "Error: no se pudo recuperar el informe de diagnóstico.",
  },
  class_progress_report: {
    "At/Above": "Al nivel o por encima",
    "On Track": "Por buen camino",
    Developing: "En desarrollo",
    Behind: "Por debajo",
    "Fall (BOY)": "Otoño (principios de año)",
    "Winter (MOY)": "Invierno (mediados de año)",
    "Spring (EOY)": "Primavera (finales de año)",
    "Estimated Mastery Today": "Dominio estimado",
    PR: "RP",
    Latest: "Más reciente",
    "Word Recognition":"Reconocimiento de palabras",
    "Comprehension": "Comprensión",
    "Fluency": "Fluidez",
    "PA": "CF",
    "DCD": "DEC",
    "WR": "RP",
    "VCB": "VOC",
    "CMP": "COMP",
    "WCPM": "PCPM",
    "ARM": "ARM",
  },
  dyslexia_risk_report: {
    Student: "Estudiante",
    "Risk Level": "Nivel de riesgo",
    "Print Letters": "Imprimir cartas",
    "Under Review": "Bajo revisión",
  },
  parent_report: {
    "Print Parent Letters": "Imprimir cartas para las familias",
    select_optional_attachments:
      "Seleccionar documentos adjuntos opcionales que desea incluir",
    "Home Activity Log": "Registro de actividad en el hogar",
    "Print letter in": "Imprimir la carta en",
  },
  review_activity: {
    title: "Seleccionar una actividad reciente para su revisión",
    Assessment: "Evaluación",
    Practice: "Práctica",
    "Letter Names and Sounds": "Nombres de las letras y los sonidos",
    "Letter Names and Sounds Rescoring Warning": "Su escuela o distrito no permite volver a puntuar la actividad de los nombres de las letras y los sonidos. Si necesita ayuda, comuníquese con el líder de su escuela o distrito.",
    Adjusted: "Con\u00A0adjuste",
    Unadjusted: "Sin\u00A0adjuste",
    WCPM: "PCPM",
    ASSESSMENT: "EVALUACIÓN",
    PRACTICE: "PRÁCTICA",
    COMPLETE: "COMPLETADA",
    INCOMPLETE: "INCOMPLETA",
    "UNDER REVIEW...": "BAJO REVISIÓN...",
    "Go To The": "Ir al",
    "Tracking Report": "Informe de seguimiento",
    "correction_header": "Se Calificará la {{activityType}} de {{studentName}} el {{month}}/{{day}}",
    "Correct": "Correcta",
    "Incorrect": "Incorrecta",
    "Not Read": "No leída",
    "Flagged": "Marcada",
    "Errors": "Errores",
    "Self Corrections": "Autocorrecciones",
    "Skips": "Omisiones",
    "Mistakes": "Equivocaciones",
    "Totals": "Totales",
    "Accuracy": "Precisión",
    "Status": "Estado",
    "Adjusted WCPM": "PCPM con ajuste",
    "Adjusted Read Time": "Tiempo de lectura con ajuste",
    "Questions?": "¿Preguntas?",
    "Scoring Reading Activity": "Puntuación de la actividad de lectura",
    "SAVE CHANGES": "GUARDAR CAMBIOS",
    // review activity tooltips
    tooltip_correct: "El estudiante leyó correctamente la palabra.",
    tooltip_incorrect: "El estudiante no decodificó correctamente esta palabra. Escúchelo para identificar sus errores.",
    tooltip_not_read: "El estudiante no terminó la historia en el tiempo asignado. Esta parte del texto no se incluye en la calificación y no afecta la puntuación de palabras correctas por minuto (PCPM).",
    tooltip_flagged: "Amira no pudo oír esta palabra debido a problemas tecnológicos o de sonido. Un docente debe escuchar el audio y volver a calificar la palabra.",
    tooltip_error: "Palabras que el estudiante omitió o leyó incorrectamente.",
    tooltip_self_corrections: "Esto indica que el estudiante lee mal al principio y luego se corrige. Si el estudiante hace varios intentos, es posible que el docente tenga que ajustar la puntuación.",
    tooltip_skips: "Situaciones en las que el estudiante omite una palabra.",
    tooltip_miscues: "Incluye los errores del estudiante, pero no la palabras omitidas.",
    tooltip_accuracy: "Se calcula dividiendo el número de palabras correctas entre el número de palabras leídas.  La puntuación no incluye las palabras omitidas al final de un texto.",
    tooltip_adj_wcpm: "Es el valor de PCPM según la complejidad del texto. No es una puntuación bruta que se pueda calcular manualmente. La puntuación PCPM bruta (sin ajuste) está disponible en el informe de progreso.",
    // scoring faq
    default_title: "¿Cómo cambio la puntuación de una palabra?",
    default_content: "Para cambiar una palabra de correcta a incorrecta, basta hacer clic en la palabra\nPara obtener más detalles sobre la puntuación, haga clic en",
    "this link": "este enlace",
    early_next_button_title: "¿El estudiante pasó a la página siguiente antes de terminar de leer?",
    early_next_button_content: "Es probable que el estudiante haya pulsado el botón “Siguiente” demasiado pronto y que por eso haya una larga cadena de errores.\{{brandedAppName}} califica esto como una OMISIÓN que no afecta la puntuación PCPM del estudiante, pero puede incidir negativamente en la evaluación global de su dominio.\nSi la puntuación le parece demasiado baja, debe volver a evaluar al estudiante.",
    inconsistent_time_title: "¿Por qué se usa un tiempo ajustado en esta puntuación PCPM?",
    inconsistent_time_content: "El tiempo utilizado para calcular la puntuación PCPM se ajustó porque se produjo alguna actividad extraña o porque el estudiante dejó de leer. Sin este ajuste, la puntuación PCPM sería incorrecta.",
  },
  admin_assessment_configuration: {
    config_grade_banner_title:
      "{{grade}} Configuration Exceeds Maximum Recommended Time",
    config_grade_banner_message:
      "The maximum assessment time recommended for {{grade}} is {{expectedTime}} minutes. The total time for {{grade}} is currently {{totalTime}} minutes",
  },
  admin_benchmark_configuration: {
    select_grades: "Choose Grades to Include",
    disable_by_grade_warning:
      "Some schools has their own grades to include settings, if you change this setting, it will override the school settings.",
    window_disabled_by_grade_warning:
      "The following grade is excluded from this screening window: {{disabledGradesString}}",
    window_disabled_by_grade_warning_plural:
      "The following grades are excluded from this screening window: {{disabledGradesString}}",
  },
  tutor_assignment_modal: {
    add_assignment: "Agregar Asignación",
    add_an_assignment: "Agregar una Asignación",
    an_assignment_has_been_added_for_number_students: "Se ha agregado una asignación para {{number}} estudiante",
    an_assignment_has_been_added_for_number_students_plural: "Se ha agregado una asignación para {{number}} estudiantes",
    the_assignment_could_not_be_created_try_again: "No se pudo crear la asignación. Inténtalo de nuevo.",
    show_all_assignable_stories_from_skyline_for: "Mostrar todas las historias asignables de Skyline para",
    with: "con",
    that_cover: "que cubren",
    assign: "Asignar",
    dismiss: "Descartar",
    please_select_students: "Por favor selecciona un estudiante",
    this_story_has_already_been_added_to_students: "Esta historia ya ha sido asignada a {{students}}",
    see_assignments: "Ver asignaciones",
  }
};
